"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getColorForPoint = exports.getStatus = exports.buildColorAccessor = exports.defaultColorAccessor = exports.MetricsGrey = exports.MetricsBadColor = exports.MetricsNeutralColor = exports.MetricsGoodColor = exports.MetricComparisonColor = exports.MetricBlueLight = exports.MetricBlue = exports.definitionWithStatus = exports.ThresholdStatus = exports.getStatusFeature = exports.STATUS_FEATURE_NAME = void 0;
var FeatureFlags_1 = require("../../componentModels/FeatureFlags");
var Accessor_1 = require("../../models/Accessor");
var EffectiveDefinition_1 = require("../../models/EffectiveDefinition");
var Result_1 = require("../../models/Result");
var IfElseCalculation_1 = require("../../transforms/calculations/IfElseCalculation");
var SimplePredicateCalculation_1 = require("../../transforms/calculations/SimplePredicateCalculation");
var metricValue_1 = require("../metricValue");
var threshold_1 = require("../threshold");
exports.STATUS_FEATURE_NAME = 'status';
var getStatusFeature = function (features) {
    return features.status;
};
exports.getStatusFeature = getStatusFeature;
var ThresholdStatus;
(function (ThresholdStatus) {
    ThresholdStatus["UNKNOWN"] = "unknown";
    ThresholdStatus["NEUTRAL"] = "neutral";
    ThresholdStatus["GOOD"] = "good";
    ThresholdStatus["BAD"] = "bad";
})(ThresholdStatus = exports.ThresholdStatus || (exports.ThresholdStatus = {}));
var definitionWithStatus = function (definition, status) {
    var _a;
    var thresholdFeature = (0, threshold_1.getThresholdFeature)(definition.features);
    if (thresholdFeature === undefined) {
        return (0, Result_1.Err)(new Result_1.MetricsEngineError('Metric definition must contain a threshold feature'));
    }
    var thresholdColumnName = (_a = (0, threshold_1.getDefaultLineForThreshold)(thresholdFeature)) === null || _a === void 0 ? void 0 : _a.measure.column;
    if (thresholdColumnName === undefined) {
        return (0, Result_1.Err)(new Result_1.MetricsEngineError('Threshold must contain measure column name'));
    }
    var statusColumnName = "status::threshold::".concat(thresholdColumnName);
    var colorColumnName = "color::threshold::".concat(thresholdColumnName);
    var newFeatures = makeFeaturesWithStatus(definition, statusColumnName, colorColumnName);
    var newSchema = makeSchemaWithStatus(definition, status, thresholdColumnName, statusColumnName, colorColumnName);
    return (0, Result_1.Ok)(__assign(__assign({}, definition), { features: newFeatures, schema: newSchema }));
};
exports.definitionWithStatus = definitionWithStatus;
var makeFeaturesWithStatus = function (definition, statusColumnName, colorColumnName) {
    var _a;
    return __assign(__assign({}, definition.features), (_a = {}, _a[exports.STATUS_FEATURE_NAME] = {
        status: { column: statusColumnName },
        color: { column: colorColumnName },
    }, _a));
};
var makeSchemaWithStatus = function (definition, status, thresholdColumnName, statusColumnName, colorColumnName) {
    var _a;
    return __assign(__assign({}, definition.schema), (_a = {}, _a[statusColumnName] = {
        type: EffectiveDefinition_1.StringType,
        name: statusColumnName,
        calculation: {
            type: IfElseCalculation_1.IfElseType,
            branches: [
                {
                    predicate: {
                        type: SimplePredicateCalculation_1.SimplePredicateType,
                        lhs: {
                            column: metricValue_1.MEASURE_COLUMN_NAME,
                        },
                        rhs: {
                            column: thresholdColumnName,
                        },
                        operator: SimplePredicateCalculation_1.ComparisonOperator.GREATER_THAN,
                    },
                    result: status.above,
                },
                {
                    predicate: {
                        type: SimplePredicateCalculation_1.SimplePredicateType,
                        lhs: {
                            column: metricValue_1.MEASURE_COLUMN_NAME,
                        },
                        rhs: {
                            column: thresholdColumnName,
                        },
                        operator: SimplePredicateCalculation_1.ComparisonOperator.EQUAL,
                    },
                    result: status.equal,
                },
                {
                    predicate: {
                        type: SimplePredicateCalculation_1.SimplePredicateType,
                        lhs: {
                            column: metricValue_1.MEASURE_COLUMN_NAME,
                        },
                        rhs: {
                            column: thresholdColumnName,
                        },
                        operator: SimplePredicateCalculation_1.ComparisonOperator.LESS_THAN,
                    },
                    result: status.below,
                },
            ],
        },
    }, _a[colorColumnName] = {
        type: EffectiveDefinition_1.StringType,
        name: colorColumnName,
        calculation: {
            type: IfElseCalculation_1.IfElseType,
            branches: [
                {
                    predicate: {
                        type: SimplePredicateCalculation_1.SimplePredicateType,
                        lhs: {
                            column: statusColumnName,
                        },
                        rhs: ThresholdStatus.GOOD,
                        operator: SimplePredicateCalculation_1.ComparisonOperator.EQUAL,
                    },
                    result: exports.MetricsGoodColor,
                },
                {
                    predicate: {
                        type: SimplePredicateCalculation_1.SimplePredicateType,
                        lhs: {
                            column: statusColumnName,
                        },
                        rhs: ThresholdStatus.NEUTRAL,
                        operator: SimplePredicateCalculation_1.ComparisonOperator.EQUAL,
                    },
                    result: exports.MetricsNeutralColor,
                },
                {
                    predicate: {
                        type: SimplePredicateCalculation_1.SimplePredicateType,
                        lhs: {
                            column: statusColumnName,
                        },
                        rhs: ThresholdStatus.BAD,
                        operator: SimplePredicateCalculation_1.ComparisonOperator.EQUAL,
                    },
                    result: exports.MetricsBadColor,
                },
            ],
        },
    }, _a));
};
exports.MetricBlue = '#2A79AF';
exports.MetricBlueLight = 'rgba(42, 121, 175, 0.4)';
exports.MetricComparisonColor = '#b4b4b4';
exports.MetricsGoodColor = '#008057';
exports.MetricsNeutralColor = '#2A79AF';
exports.MetricsBadColor = '#C93A47';
exports.MetricsGrey = '#333';
var defaultColorAccessor = function (_) {
    return exports.MetricsNeutralColor;
};
exports.defaultColorAccessor = defaultColorAccessor;
var buildColorAccessor = function (effectiveDefinition) {
    var _a;
    var status = (0, exports.getStatusFeature)(effectiveDefinition.features);
    if (!((_a = status === null || status === void 0 ? void 0 : status.color) === null || _a === void 0 ? void 0 : _a.column)) {
        return exports.defaultColorAccessor;
    }
    return function (dataRow) { var _a; return (_a = dataRow[status.color.column]) !== null && _a !== void 0 ? _a : exports.MetricsNeutralColor; };
};
exports.buildColorAccessor = buildColorAccessor;
var getStatus = function (effectiveDefinition, featureFlags, selectedRow) {
    var _a;
    var colorIndicatorsEnabled = featureFlags[FeatureFlags_1.COLOR_INDICATORS_FLAG];
    if (!colorIndicatorsEnabled) {
        return ThresholdStatus.UNKNOWN;
    }
    var statusFeature = (0, exports.getStatusFeature)(effectiveDefinition.features);
    var status = (_a = (statusFeature && selectedRow && (0, Accessor_1.accessorForReference)(statusFeature.status)(selectedRow))) !== null && _a !== void 0 ? _a : ThresholdStatus.UNKNOWN;
    return status;
};
exports.getStatus = getStatus;
var getColorForPoint = function (effectiveDefinition, value) {
    var colorAccessor = (0, exports.buildColorAccessor)(effectiveDefinition);
    return value ? colorAccessor(value) : undefined;
};
exports.getColorForPoint = getColorForPoint;
//# sourceMappingURL=index.js.map